export default "__VITE_ASSET__0e00d0e6__"